import { deepCopy, getDataScopeByPermission, getFacilityByPermission, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { FacilityService } from 'src/app/core/services/facility.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { TruckCostAllocationService } from '../../services/truck-cost-allocation.service';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';


@Component({
  selector: 'laas-import-cross-boundry',
  templateUrl: './import-cross-boundry.component.html',
  styleUrl: './import-cross-boundry.component.scss'
})

export class ImportCrossBoundryComponent extends SessionBaseComponent implements OnInit {
  @ViewChild('headerTable') dataTable!: DataTableComponent;

  readonly permissionCode: PermissionConstants = PermissionConstants.EditTruckCostAllocation;
  defaultSearchParams: any;

  @Input() searchResults:any[];
  @Output() closeImportCrossBoundryEvent: EventEmitter<any>;
  @ViewChild('createDt') createDt!: CalendarComponent;

  searchForm: FormGroup;

  columns: any[];
  selectedDORows: any[];
  searchParams: any;
  forwarderOptions: any[];

  selectedRows: any[] = [];
  isShowCreateDialog: boolean = false;
  deliveryTypeOptions: any[];
  facilityOptions: any[];
  countryOptions: any[];
  fromCityOptions: any[];
  toCityOptions: any[];
  fromAreaOptions: any[];
  toAreaOptions: any[];
  cityOptions: any[];
  areaAllOptions: any[];
  bookingReferenceKeys: any[];
  warehousingReferenceKeys: any[];
  hasCrossBoundryOptions: any[];

  isLoading: boolean = false;
  isSearchFormOpen: boolean = true;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "createDt",
    direction: -1
  };

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private addressMaintainanceService: AddressMaintainanceService,
    private truckCostAllocationService: TruckCostAllocationService,
    private fb: FormBuilder,
    private dropdownOptionService: DropdownOptionsService) {
    super(injector);
    this.closeImportCrossBoundryEvent = new EventEmitter<any>();
    this.searchParams = {
      registrationKey: [],
      referenceType: null,
      referenceKeys: [],
      forwarder: null,
      createStartDt: null,
      createEndDt: null,
      consolidationNos:[],
      dataScopes:null,
      carTrips:[],
      hasCrossBoundry:null
    }

    this.searchForm = this.fb.group({
      referenceKeys:[null],
      customsForwarders:[null],
      deliveryType: null,
      carTrips: [null],
      consolidationNos: [null],
      containerCodes: [null],
      facilityList: [null],
      fromCountry: null,
      fromCity: null,
      fromArea: [null],
      toCountry: null,
      toCity: null,
      toArea:  [null],
      createStartDt: null,
      createEndDt: null,
      hasCrossBoundry: null
    })

    this.columns = [
      { field: 'referenceType', header: 'ImportCrossBoundryDialog.MainTable.ReferenceType', sort: true },
      { field: 'referenceKey', header: 'ImportCrossBoundryDialog.MainTable.ReferenceKey', sort: true },
      { field: 'forwarder', header: 'ImportCrossBoundryDialog.MainTable.Forwarder', sort: true },
      { field: 'deliveryType', header: 'ImportCrossBoundryDialog.MainTable.DeliveryType', sort: true },
      { field: 'fromCountry', header: 'ImportCrossBoundryDialog.MainTable.FromCountry', sort: true },
      { field: 'fromCity', header: 'ImportCrossBoundryDialog.MainTable.FromCity', sort: true },
      { field: 'fromArea', header: 'ImportCrossBoundryDialog.MainTable.FromArea', sort: true },
      { field: 'toCountry', header: 'ImportCrossBoundryDialog.MainTable.ToCountry', sort: true },
      { field: 'toCity', header: 'ImportCrossBoundryDialog.MainTable.ToCity', sort: true },
      { field: 'toArea', header: 'ImportCrossBoundryDialog.MainTable.ToArea', sort: true },

    ]

    this.searchResults= [];
    this.selectedDORows = [];
    this.forwarderOptions = [];
    this.deliveryTypeOptions = [];
    this.bookingReferenceKeys = [];
    this.warehousingReferenceKeys = [];
    this.facilityOptions = [];
    this.countryOptions = [];
    this.fromCityOptions = [];
    this.toCityOptions = [];
    this.fromAreaOptions = [];
    this.toAreaOptions = [];
    this.cityOptions = [];
    this.areaAllOptions = [];
    this.hasCrossBoundryOptions = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.filter(x => {
          return this.userProfile.userType == UserType.SuperAdmin.toString() ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(null) ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(x.optionCode)
        })
        .map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
          this.userProfile.userType === UserType.Shipping.toString() ||
          getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
      }
    });


    this.dropdownOptionsService.getRfqCategoryTypeOptions()
    .subscribe({
      next: (options: any[]) => {
        this.deliveryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.cityOptions = this.toCityOptions = this.fromCityOptions = [...result].map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
            country: x.country
          };
        });
      }
    });

    this.dropdownOptionsService.getAllAreaOptionForHK().subscribe({
      next: result => {
        this.areaAllOptions = [...result].filter((x: any) => x.rfqAreaName && x.rfqAreaCode).map((x: any) => {
          return {
            label: x.rfqAreaName,
            value: x.rfqAreaCode,
            citySeqNo : x.citySeqNo,
          };
        });
      }
    });

    this.dropdownOptionService.getHasCrossBoundryOptions().subscribe({
      next: (options: any[]) => {
        this.hasCrossBoundryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

  }

  searchBtnClick() {
    this.dataTable.cancelRowEdit();
    this.dataTable.isInEditMode = false;
    this.dataTable.setCurrentPage(0);
    this.searchResult();
  }

  searchResult() {
    const params = deepCopy(this.searchForm.value);
    console.log('params: ' + JSON.stringify(this.searchForm.value));
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    this.isLoading = true;
    this.truckCostAllocationService.searchDataForCrossBoundry(params)
    .pipe(finalize(() => this.isLoading = false))
    .subscribe({
      next: (response) => {
        this.searchResults = response.content;
        console.log('params: ' + JSON.stringify(this.searchResults));
        // Change page Info
        this.pageInfo.totalRecords = response.totalElements;
        this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
      },
      error: (err: HttpErrorResponse) => {
        this.pageInfo.totalRecords = 0;
        this.pageInfo.totalPages = 0;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        this.toastErrorMessage(err.error);
      },
    });
  }

  resetBtnClick(event: any) {
    this.searchForm.reset();
    this.createDt.ngOnInit();
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }


  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.dataTable.setCurrentPage(0);
    this.searchBtnClick();
  }

 /**
   * chips add event.
   *
   * @param event p-chips onAdd event.
   * @param param
   */
  chipsAdd(event: any, param: string): void {
    const value: string = event.value;

    console.log("原始貼上內容：", JSON.stringify(value));

    const parsedValues: string[] = value
      .split(/\r?\n/)
      .map((x) => x.trim())  // 去除每一行開頭和結尾的空白字元（包括 tab、空格、換行）
      .map((x) => x.replace(/\s+/g, '')) // 去除每行內的多餘空白字元
      .filter((x) => x.length > 0);  // 過濾掉空字串

    this.searchParams[param].splice(this.searchParams[param].indexOf(0));
    this.searchParams[param] = this.searchParams[param].concat(parsedValues);
  }

  dateOnChange(date: any) {
      this.searchForm.controls.createStartDt.setValue(date.startDate);
      this.searchForm.controls.createEndDt.setValue(date.endDate);
  }

  importCbBtnLCick(event: any): void {
    console.log("this.selectedRows======" + this.selectedRows);
    let forwarders = this.selectedRows.filter(x => x.forwarder).map(x => x.forwarder);


    this.bookingReferenceKeys = this.selectedRows.filter(x => x.referenceType === 'Booking').map(x => x.referenceKey);
    this.warehousingReferenceKeys = this.selectedRows.filter(x => x.referenceType === 'Warehousing').map(x => x.referenceKey);
    this.isShowCreateDialog =  true;
  }

  async onCountryChange(event: any, type: string): Promise<void> {
    if (type === 'from') {
      if (!isNullOrEmpty(this.searchForm.get('fromCountry')?.value)) {
        const fromCountry = this.searchForm.get('fromCountry')?.value;
        this.fromCityOptions = await this.getCityOptions(fromCountry);
      }
      if (!isNullOrEmpty(this.searchForm.get('fromCountry')?.value) && !isNullOrEmpty(this.searchForm.get('fromCity')?.value)) {
        console.log("我有近來from" +this.searchForm.get('fromCountry')?.value +this.searchForm.get('fromCity')?.value);
        this.fromAreaOptions =  this.areaAllOptions;
        this.fromAreaOptions = this.fromAreaOptions.filter(x => x.citySeqNo?.toString() === this.searchForm.get('fromCity')?.value);
      }
    } else if (type === 'to') {
      if (!isNullOrEmpty(this.searchForm.get('toCountry')?.value)) {
        const toCountry = this.searchForm.get('toCountry')?.value;
        this.toCityOptions = await this.getCityOptions(toCountry);
      }
      if (!isNullOrEmpty(this.searchForm.get('toCountry')?.value) && !isNullOrEmpty(this.searchForm.get('toCity')?.value)) {
        this.toAreaOptions =  this.areaAllOptions;
        this.toAreaOptions = this.toAreaOptions.filter(x => x.citySeqNo?.toString() === this.searchForm.get('toCity')?.value);
      }
    }
  }

  async getCityOptions(country: string): Promise<any[]> {
    var cityOptions: any[] = [];
    cityOptions = await this.addressMaintainanceService.getCityOptions(country);
    cityOptions = cityOptions.map(x => ({
      label: `${x.name}-${x.enName}`,
      value: x.seqNo.toString()
    }));
    return cityOptions;
  }


  closeCreateCrossBoundryEvent(event: any): void {
    this.isShowCreateDialog = false;
    this.closeImportCrossBoundryEvent.emit({ originalEvent: event });
  }

}

